import React, { useState } from 'react';
import { Icons } from '../../../components/base/BootstrapComponents';

export function StatusHelperTooltip() {
  return (
    <div className="parking-meter-helper-tooltip parking-meter-status-helper-tooltip">
      <div className="pmh-block">
        <div className="pmh-title">Легенда</div>
        <div className="pmh-table">
          <div className="pmh-column">
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon good-state" /></div>
              <div className="pmh-text">Был доступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon warning-state" /></div>
              <div className="pmh-text">Был недоступен менее 3 часов</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon error-state" /></div>
              <div className="pmh-text">Был недоступен более 3 часов</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default function HelperTooltip() {
  return (
    <div className="parking-meter-helper-tooltip">
      <div className="pmh-block">
        <div className="pmh-title">Легенда</div>
        <div className="pmh-table">
          <div className="pmh-column pmh-left-column">
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon good-state" /></div>
              <div className="pmh-text">Доступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon warning-state" /></div>
              <div className="pmh-text">Временно недоступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><div className="pmh-status-icon error-state" /></div>
              <div className="pmh-text">Недоступен</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="where-to-vote" className="pmh-icon where-to-vote" /></div>
              <div className="pmh-text">Переход на карту</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="unlocked-opened" className="pmh-icon unlocked-opened" /></div>
              <div className="pmh-text">Замок на двери открыт</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="unlocked-closed" className="pmh-icon unlocked-closed" /></div>
              <div className="pmh-text">Замок разблокирован и закрыт</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="unlocked-closed" className="pmh-icon unlocked-closed-close" /></div>
              <div className="pmh-text">Замок на двери заблокирован</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="lock-undefined" className="pmh-icon lock-undefined" /></div>
              <div className="pmh-text">Состояние замка неизвестно</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="lock-error" className="pmh-icon lock-error" /></div>
              <div className="pmh-text">Ошибка</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="battery-charging-full" className="pmh-icon battery-charging-full" /></div>
              <div className="pmh-text">Зарядка аккумулятора</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="battery-charging-full-2" className="pmh-icon battery-charging-full-2" /></div>
              <div className="pmh-text">Низкий заряд аккумулятора</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="power" className="pmh-icon power" /></div>
              <div className="pmh-text">Питание от сети</div>
            </div>
          </div>
          <div className="pmh-column pmh-right-column">
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="replay" className="pmh-icon replay" /></div>
              <div className="pmh-text">Перезагрузка компьютера</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="unlock-top-door" className="pmh-icon unlock-top-door" /></div>
              <div className="pmh-text">Разблокировать верхний замок</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="unlock-bottom-door" className="pmh-icon unlock-bottom-door" /></div>
              <div className="pmh-text">Разблокировать нижний замок</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="construction" className="pmh-icon construction" /></div>
              <div className="pmh-text">Сервисный режим</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="door-open" className="pmh-icon door-open" /></div>
              <div className="pmh-text">Дверь открыта</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="door-closed" className="pmh-icon door-closed" /></div>
              <div className="pmh-text">Дверь закрыта</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="door-undefined" className="pmh-icon door-undefined" /></div>
              <div className="pmh-text">Состояние двери неизвестно</div>
            </div>

            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="brightness" className="pmh-icon brightness" /></div>
              <div className="pmh-text">Солнечная батарея</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="brightness-5" className="pmh-icon brightness-5" /></div>
              <div className="pmh-text">Нет подключения к питанию</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="load" className="pmh-icon load" /></div>
              <div className="pmh-text">Нагрузка аккумулятора</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="load" className="pmh-icon load-2" /></div>
              <div className="pmh-text">Низкий заряд аккумулятора</div>
            </div>
            <div className="pmh-row">
              <div className="pmh-icon-wrapper"><Icons customIcon icon="more-vert" className="pmh-icon more-vert" /></div>
              <div className="pmh-text">Другие команды</div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
